(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categories-slider"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("DOMContentLoaded", (event) => {
    //console.log("DOM fully loaded and parsed");
    var elem = document.querySelector('.cs-slider');
    var buttons = document.querySelectorAll('.cs-nav-item');
    var flkty = new Flickity( elem, {
      cellAlign: 'left',
      contain: true,
      draggable: true,
      freeScroll: true,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      hash: true,
      on: {
        ready: function() {
          //console.log('Flickity is ready');
        },
        change: function( index ) {
          //console.log( 'Slide changed to' + index );
          buttons.forEach((btn) => {
             btn.classList.remove("active");
             var count = btn.getAttribute('data-index');
             if(count == index){
               btn.classList.add("active");
                if (window.innerWidth < 768){
                  //console.log(btn);
                  //console.log('scroll left',btn.scrollLeft,btn.offsetLeft);
                  if(count == "0" || count == "1" || count == "2"){
                    console.log('count stsart',count,document.querySelector('.cs-slider-nav').scrollLeft)
                    document.querySelector('.cs-slider-nav').scrollBy({
                    left: -475,
                    behavior: "smooth",
                  });
                  }else{
                    document.querySelector('.cs-slider-nav').scrollBy({
                    left: (btn.offsetLeft - 17 ),
                    behavior: "smooth",
                  });
                  }

                  // buttons.
                  // btn.. scrollTo({ top: div. scrollHeight, behavior: 'smooth' });
                  // elem.scrollIntoView();
                }
               //console.log('btn',btn)
             }
           })
        }
      }
    });

    buttons.forEach((btn) => {
      btn.addEventListener("click", function(){
       buttons.forEach((btn) => {
         btn.classList.remove("active");
       });
       var count = btn.getAttribute('data-index');
       btn.classList.add("active");
       flkty.select(count,false,false);
     });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
